import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  padding-top: 19px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  height: 214px;
  padding: 28px 12px 16px;
`;

export const Bg = styled.img`
  position: absolute;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  user-select: none;
`;

export const Label = styled.div<{ gap?: boolean }>`
  position: relative;
  font-size: 14px;
  font-weight: 600;
  color: #055337;
  ${(p) =>
    p.gap &&
    css`
      margin-left: 20px;
      &::before {
        content: "";
        position: absolute;
        height: 12px;
        width: 1px;
        border-left: 1px solid #055337;
        top: 50%;
        left: -10px;
        transform: translate(0, -50%);
      }
    `}
`;

export const LabelWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const Value = styled.div<{ gap?: boolean }>`
  position: relative;
  font-size: 22px;
  font-weight: 500;
  .unit {
    font-size: 12px;
    margin-right: 2px;
  }
  ${(p) =>
    p.gap &&
    css`
      margin-left: 20px;
      &::before {
        content: "";
        position: absolute;
        height: 12px;
        width: 1px;
        border-left: 1px solid #d0f6e9;
        top: 50%;
        left: -10px;
        transform: translate(0, -50%);
      }
    `}
`;

export const ValueWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 12px;
`;

export const RechargeButton = styled.button`
  all: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 36px;
  border-radius: 48px;
  border: 0.5px solid white;
  background: linear-gradient(
    170.29deg,
    rgba(255, 255, 255, 0.8) 7.31%,
    rgba(255, 255, 255, 0.56) 95.56%
  );
  span {
    background: linear-gradient(107.56deg, #03a34c 11.11%, #08b7cf 100.34%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 600;
  }
`;

export const Cumulative = styled.div`
  position: absolute;
  bottom: 76px;
  font-size: 12px;
  color: #ffffff;
  .unit {
    margin-left: 5px;
  }
`;
